import { convertToDefaultDateFormat, truncateString, getDOW, convertToDefaultDateFormatDDD, formatingToDDD, getDOWDutchDDD } from "@/util"
import ReservationRequestDTO from "../modules/candidates/core/DTO/reservationRequestDTO"
import CMExamConfig, { CMOverviewExamConfigDecorator} from "../modules/course_managment/classes/CMExamConfig"

function getDateAndName(_date, date, name) {
  if (name && date) return `${getDOWDutchDDD(new Date(_date).getDay())} ${date} - ${truncateString(name, 40)}`
  else if(name) return `${truncateString(name, 40)}`
  return `${formatingToDDD(date)} ${date}`
}

function getCourseLabel(_date, date, name) {
  if (name && date) return `${getDOWDutchDDD(new Date(_date).getDay())} ${date} - ${truncateString(name, 40)}`
  else if(name) return `${truncateString(name, 40)}`
  return `${formatingToDDD(date)} ${date}`
}

export default class CourseModel {
  constructor(item = {}) {
    this.ID = item.id
    this._date = item.date
    this.date = convertToDefaultDateFormat(item.date)
    this.city = item.city
    this.name = item.name
    this.candidatesCount = item.candidates_count
    this.topCbrQueueCount = item.top_cbr_queue_count
    this.topCbrReserveQueueCount = item.top_cbr_reserve_queue_count
    this.topCbrExchangeQueueCount = item.top_cbr_exchange_queue_count
    this.mijnCbrQueueCount = item.mijn_cbr_queue_count
    this.exams = item.exams && item.exams.length ? item.exams.map(item => new CMExamConfig(item)) : []
  }

  get originDate() {
    return this._date
  }

  get dateAndName() {
    return getDateAndName(this._date, this.date, this.name)
  }
}

export class CourseModelDetailed{
  constructor(item = {}) {
    this.ID = item.id
    this._date = item.date
    this.date = item.date ? convertToDefaultDateFormat(item.date) : ''
    this.city = item.city
    this.candidatesCount = item.candidates_count
    this.topCbrQueueCount = item.top_cbr_queue_count
    this.topCbrReserveQueueCount = item.top_cbr_reserve_queue_count
    this.topCbrExchangeQueueCount = item.top_cbr_exchange_queue_count
    this.mijnCbrQueueCount = item.mijn_cbr_candidates_count
    this.exams = item.exams && item.exams.length ?
      item.exams.map(item => new CMOverviewExamConfigDecorator(new CMExamConfig(item)).convert()) :
      []
    this.maxStudents = item.max_students
    this.slotsCount = item.slots_count
    this.notes = item.notes
    this.name = item.name
    this.freePlaces = item.free_places.toString()
    this.isVisibleOnLanding = item.is_visible_on_landing
    this.leaders = item.leaders
    this.is_provided = item.is_provided
  }

  get originDate() {
    return this._date
  }

  get dateAndName() {
    return getDateAndName(this._date, this.date, this.name)
  }
}

export class CourseEditable {
  constructor(item = {}) {
    this.city = item.city || ''
    this.date = item.date || ''
    this.notes = item.notes || ''
    this.freePlaces = item.free_places || 8
    this.isVisibleOnLanding = item.isVisibleOnLanding || null
    this.maxStudents = item.max_students || 0
    this.name = item.name
    this.is_provided = typeof item.is_provided === 'boolean' ? item.is_provided : true
  }
}

export class CourseMini {
  constructor(item = {}) {
    this.item = item
  }

  get() {
    return {
      ...this.item,
      label: this.getLabel()
    }
  }

  getLabel() {
    let dateFormatted = convertToDefaultDateFormat(this.item.date)
    if (this.item.name && this.item.date) 
      return `${getDOWDutchDDD(new Date(this.item.date).getDay())} ${dateFormatted} ${this.item.city} ${truncateString(this.item.name, 40)}`
    else if(this.item.name) return `${this.item.city} ${truncateString(this.item.name, 40)}`
    return `${getDOWDutchDDD(new Date(this.item.date).getDay())} ${dateFormatted} ${this.item.city}`
  }
}